export default {
  reviewCompleteHeader: 'レビューして完了',
  participants: '参加者',
  enterParticipantInfoText: 'この体験の各参加者の情報を入力してください。',
  purchaser: '購入者',
  firstName: '名',
  lastName: '姓',
  email: 'メール',
  optionalEmail: 'メール（任意）',
  'phone:': '電話',
  participantFieldPlaceholder: '新規追加または既存の参加者を選択',
  reservationSummary: '予約概要',
  editParticipantsDetails: '参加者の詳細を編集',
  participantDetails: '参加者の詳細',
  duplicatePurchaserText: '購入者と同じ',
  phone: '電話',
  addParticipant: '追加 {{tierLabel}}',
  participant: '参加者',
  removeParticipant: '削除',
  experienceCheckoutCompleted: 'エクスペリエンスのチェックアウト完了',
  experienceCartCheckout: 'エクスペリエンスカートのチェックアウト',
  experienceLimitReached: ' この体験は参加者数の最大限に達しました',
  payment: '支払い',
  duration: '期間',
  discountCode: '割引コード',
  removeCode: 'コードを削除',
  invalidCodeValidation: '無効なクーポンコード',
  networkErrorDiscountCode: '何か問題が発生しました',
  onlyOneCouponCodeAllowed: '割引コードは1つのみ使用できます',
  creditCodeHasAlreadyBeenApplied: 'クレジットコードはすでに適用されています',
  discount: '割引',
  promo: 'プロモーション',
  promoCode: 'プロモーションコード',
  apply: '適用',
  total: '合計',
  subTotal: '小計',
  includes: '含む',
  and: 'と',
  addHostNotes: 'ホストへのメモを追加',
  policyAggreementText:
    '<0>利用規約</0>と<1>プライバシーポリシー</1>に同意します',
  brandAggreementText:
    ' または、私はこの参加者を代表して同意する権限があることを証明します',
  termsAggreementValidation: '利用規約に同意してください。',
  firstNameValidation: '名前は必須です',
  lastNameValidation: '苗字は必須です',
  emailValidation: {
    emailRequiredText: 'メールアドレスは必須です',
    invalidEmail: '無効なメールアドレスです',
    not_specified: 'メールアドレスが正しくありません',
  },
  phoneValidation: {
    'Invalid Phone Number': '無効な電話番号です',
    not_specified: '無効です',
    phoneRequiredText: '電話番号は必須です',
  },
  participantFirstNameValidation: '参加者の名前は必須です',
  participantLastNameValidation: '参加者の姓は必須です',
  complete: '完了',
  '404Message': '見つかりません',
  waiting: 'お待ちください',
  complimentary: '無料提供',
  confirmationHeader: 'ご予約いただきました！',
  confirmationText:
    '確認メールが{{email}}宛に追加の詳細を含めて送信されました。',
  viewAll: 'すべての体験を表示',
  paymentMethod: '支払い方法',
  creditCard: 'クレジットカード',
  roomCharge: '部屋代',
  memberCharge: '会員料金',
  roomOrReservationNumber: '部屋番号または予約確認番号',
  roomNumber: '部屋番号',
  roomNumberLegacy: '部屋番号または予約確認コード',
  memberNumber: '会員番号',
  kicc: 'イージーペイ',
  chargeValidation: '部屋番号と姓は必須です。',
  memberNumberValidation: '会員番号は必須です',
  invalidRoomNumber: '部屋番号が無効です',
  invalidRoomNumberLegacy: '部屋番号または予約コードが無効です',
  invalidMemberNumber: '会員番号が無効です',
  invalidPhoneNumber: '電話番号が無効です',
  guestNameIsRequired: 'ゲスト名は必須です',
  roomNumberIsRequired: '部屋番号は必須です',
  roomNumberIsRequiredLegacy: '部屋番号または予約コードは必須です',
  roomOrReservationNumberIsRequired: '部屋番号または予約確認番号が必要です',
  cardNumberIncomplete: 'カード番号が不完全です',
  lastNameValidationError: '姓は必要です',
  isReqd: '必要です',
  reservationCode: '予約/確認番号',
  nonHotelGuest: 'ホテルのゲストでない',
  onPropertyGuest: '宿泊中のゲスト',
  preArrivalGuest: '到着前のゲスト',
  cardNumber: 'カード番号',
  pmsValidationErrorMessage: '無効な姓または部屋番号または予約確認番号',
  pmsDateValidationErrorMessage:
    '申し訳ありません！体験の日付は、到着日と出発日の間に含まれていません。',
  fullName: 'フルネーム',
  checkout: 'チェックアウト',
  editParticipants: '参加者の編集',
  private: 'プライベート',
  browseAllExperieces: 'すべての体験を見る',
  payWithCreditCard: 'クレジットカードで支払う',
  payWithRoomCharge: '部屋代で支払う',
  payWithMemberCharge: '会員料金で支払う',
  payWith: '支払う',
  bookBulkErrorByCard:
    '予約の確認中に問題が発生しました。カードは請求されていません',
  bookBulkErrorByRoomCharge: '姓と部屋番号が無効です。',
  bookBulkErrorByMemberCharge: '姓と会員番号が無効です。',
  reviewCancellation: 'キャンセル',
  selectAReservationToCancel: 'キャンセルする予約を選択',
  confirmCancellation: 'キャンセルを確認',
  cancellable: 'キャンセル可能',
  cancelled: 'キャンセル済み',
  deadlinePassed: '期限切れ',
  noCancellations: 'キャンセル不可',
  reviewReschedule: 'ご予約',
  selectAReservationToReschedule: '再予約する予約を選択してください',
  confirmReservation: '予約を確定する',
  confirm: '確認する',
  selectADateAndTime: '日付と時間を選択してください',
  noOtherSessionsAvailableForThisExperience:
    'この体験には他のセッションは利用できません。',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'この予約はこれ以上再予約できません。{{brandEmail}} にメールしてください',
  thisReservationCannotBeRescheduled: 'この予約は再予約できません',
  noTimesAvailable: '利用可能な時間がありません',
  noBookingsAvailable: '予約は利用できません',
  youPaid: '支払いました',
  refund: '払い戻し',
  yourRefund: '払い戻し',
  yourRefundWillBeProcessedToTheOriginalPayment:
    '払い戻しは元の支払い方法に処理されます',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'この予約はキャンセルできなくなりました。メールでお問い合わせください {{brandEmail}}',
  reservationCancelled: '予約がキャンセルされました',
  thisReservationCannotBeCancelled: 'この予約はキャンセルできません',
  thisReservationHasAlreadyBeenCancelled:
    'この予約はすでにキャンセルされています',
  theHotel: 'ホテル',
  cancelling: 'キャンセル中',
  somethingWentWrong: '問題が発生しました',
  previouslyRefunded: '以前に払い戻された',
  remainingBalance: '残高',
  phoneNumber: '電話番号',
  requestToBookConfirmationText: '確認メールが{{email}}宛に送信されました',
  reservationRescheduled: '予約が再調整されました',
  yourReservationWasRescheduledTo: 'ご予約は次の日時に再調整されました:',
  viewExperiences: '体験を見る',
  joinBook: '参加して予約する',
  signInBook: 'サインインして予約する',
  signAndJoin: 'サインインまたは参加して予約する',
  signAndJoinDescription:
    'World of Hyatt FIND体験はWorld of Hyattメンバー専用です。サインインまたは参加して予約し、ポイントを獲得します。参加したくないですか？ World of Hyatt Experienceをカートから削除すると、非排他的な体験を予約できます。',
  promoOrFind: 'プロモコードまたはFINDクレジットコード',
  hyattTermsAndConditions: '利用規約',
  hyattTermsAndConditionsAgreement:
    'この予約を確定することで、キャンセルポリシーに同意したものとみなされます。また、以下に従って個人情報の使用を確認し、同意します：',
  hyattTermsAndConditionsLink: 'ハイアットのプライバシーポリシー',
  hyattWaiverText:
    'この体験を購入することにより、自分自身および私が購入した体験に参加するすべての個人（該当する場合）を代表して、以下の事項に同意し、理解し、承諾します',
  hyattWaiverLink: '一般免責事項',
  priceDisclaimer: '税金前の料金を含む',
  curatedRecommendations: 'カスタマイズされたおすすめ',
  moreExperiencesYouMightLike: 'あなたにおすすめの体験',
  similarExperiencesAvailableToBookDirectly: '直接予約できる類似の体験',
  experiencesAvailableAroundYourBookingDate: 'あなたの予約日付付近の体験',
  confirmationEmailSent: 'あなたの確認メールが{{email}}に送信されました。',
  youreBooked: 'あなたは予約されました',
  purchaserInformation: '購入者情報',
  requiredFieldIndicator: '* は必須項目です',
  resourceSelectionTitle: 'オプションを選択',
  resourceSelectionDescription:
    '予約の各アイテムについてオプションを選択してください。',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: '{{attributeName}}を選択',
  resourceValueSoldOut: '{{label}}（売り切れ）',
  resourceValueUnavailableWith: '{{label}}（{{picks}}では選択できません）',
  resourceOptionsUnavailable:
    'この時間のオプションを読み込めませんでした。もう一度お試しください。',
  resourceOptionsRetry: '再試行',
  changeResourceSelections: '選択を変更',
};
